/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.zoom-panel[_ngcontent-%COMP%]{background-color:#fff;padding:0;display:flex;justify-content:flex-start;align-items:center}.zoom-panel[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:35px}.zoom-panel[_ngcontent-%COMP%]   app-button[_ngcontent-%COMP%]{flex-direction:column;justify-content:center;align-items:center}.zoom-panel[_ngcontent-%COMP%]   .zoom-panel-text[_ngcontent-%COMP%]{font-size:12px;text-align:center;font-weight:700;width:50px}"];
export { styles as styles };
